import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/webinario/webinario-client.tsx");
